<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" :style="scrollStyle">
      <transition-group>
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="[{ tagActive: isActive(tag) }, { 'home-active': tag.meta.affix }]"
          :to="tag"
          class="tags-view-item"
          @click.middle.native="closeSelectedTag(tag)"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          {{ tag.meta.title }}
          <span class="delete-img" v-if="!tag.meta.affix">
            <img
              src="../assets/tableImg/delete.svg"
              alt=""
              @click.prevent.stop="closeSelectedTag(tag)"
            />
          </span>
          <!--<span-->
          <!--  v-if="!tag.meta.affix"-->
          <!--  class="el-icon-close"-->
          <!--  @click.prevent.stop="closeSelectedTag(tag)"-->
          <!--/>-->
        </router-link>
      </transition-group>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <!-- <li @click="refreshSelectedTag(selectedTag)">{{ $t('tagsView.refresh') }}</li> -->
      <li
        v-if="!(selectedTag.meta && selectedTag.meta.affix)"
        @click="closeSelectedTag(selectedTag)"
      >
        {{ $t('tagsView.close') }}
      </li>
      <li @click="closeOthersTags">{{ $t('tagsView.closeOthers') }}</li>
      <li @click="closeAllTags(selectedTag)">{{ $t('tagsView.closeAll') }}</li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ScrollPane from './ScrollPane';
  import path from 'path';
  import bus from '../common/js/bus';

  export default {
    components: { ScrollPane },
    data() {
      return {
        collapse: false,
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {},
        affixTags: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      scrollStyle() {
        if (this.collapse) {
          return {
            width: `calc(100vw - 76px)`,
          };
        } else {
          return {
            width: `calc(100vw - 250px)`,
          };
        }
      },
      visitedViews: {
        get() {
          return this.$store.state.tagsView.visitedViews;
        },
        set(value) {
          this.$store.dispatch('tagsView/coverVisitedView', value);
        },
      },
    },
    watch: {
      $route() {
        this.addTags();
        this.moveToCurrentTag();
      },
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu);
        } else {
          document.body.removeEventListener('click', this.closeMenu);
        }
      },
    },
    created() {
      // 左侧菜单栏收缩
      bus.$on('collapse', (msg) => {
        this.collapse = msg;
      });
      this.initTags();
      this.addTags();
    },
    mounted() {
      // this.initTags()
      // this.addTags()
    },
    methods: {
      move(evt, originalEvent) {
        console.log(evt, originalEvent);
      },
      isActive(route) {
        return route.path === this.$route.path;
      },
      filterAffixTags(routes, basePath = '/') {
        let tags = [];
        routes.forEach((route) => {
          if (route.meta && route.meta.affix) {
            const tagPath = path.resolve(basePath, route.path);
            tags.push({
              fullPath: tagPath,
              path: tagPath,
              name: route.name,
              meta: { ...route.meta },
            });
          }
          if (route.children) {
            const tempTags = this.filterAffixTags(route.children, route.path);
            if (tempTags.length >= 1) {
              tags = [...tags, ...tempTags];
            }
          }
        });
        return tags;
      },
      initTags() {
        const affixTags = (this.affixTags = this.filterAffixTags(this.$router.options.routes));
        for (const tag of affixTags) {
          // Must have tag name
          if (tag.name) {
            this.$store.dispatch('tagsView/addVisitedView', tag);
          }
        }
      },
      addTags() {
        const { name } = this.$route;
        if (name) {
          this.$store.dispatch('tagsView/addView', this.$route);
        }
        return false;
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag;
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag);
              // when query is different then update
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tagsView/updateVisitedView', this.$route);
              }
              break;
            }
          }
        });
      },
      refreshSelectedTag(view) {
        this.$store.dispatch('tagsView/delCachedView', view).then(() => {
          const { fullPath } = view;
          this.$nextTick(() => {
            this.$router.replace({
              path: '/redirect' + fullPath,
            });
          });
        });
      },
      closeSelectedTag(view) {
        this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews);
          }
        });
      },
      closeOthersTags() {
        this.$router.push(this.selectedTag);
        this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
          this.moveToCurrentTag();
        });
      },
      closeAllTags(view) {
        this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
          if (this.affixTags.some((tag) => tag.path === view.path)) {
            return;
          }
          this.toLastView(visitedViews);
        });
      },
      toLastView(visitedViews) {
        const latestView = visitedViews.slice(-1)[0];
        if (latestView) {
          this.$router.push(latestView);
        } else {
          // You can set another route
          this.$router.push('/');
        }
      },
      openMenu(tag, e) {
        const menuMinWidth = 105;
        const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
        const offsetWidth = this.$el.offsetWidth; // container width
        const maxLeft = offsetWidth - menuMinWidth; // left boundary
        // this.collapse 表示左侧菜单栏的开启关闭状态
        const left = e.clientX - offsetLeft + 15; // 15: margin right
        if (left > maxLeft) {
          this.left = maxLeft;
        } else {
          this.left = left;
        }

        this.top = e.clientY - 30;
        this.visible = true;
        this.selectedTag = tag;
      },
      closeMenu() {
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tags-view-container {
    width: 100%;
    position: fixed;
    z-index: 10;
    .tags-view-wrapper {
      background: #fff;
      height: 46px;
      border-bottom: 1px solid #d8dce5;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
      ::v-deep .el-scrollbar__wrap {
        padding-top: 10px;
      }
      .tags-view-item {
        display: inline-block;
        position: relative;
        height: 34px;
        line-height: 34px;
        color: #666;
        background: #fff;
        padding: 0px 10px 0px 10px;
        font-size: 12px;
        margin-right: 5px;
        &.home-active {
          padding: 0px 16px;
        }
        &.tagActive {
          background-color: #f2f2f2;
          border-radius: 6px 6px 0 0;
          border-bottom: 2px solid transparent;
        }
        &:hover {
          border-bottom: 2px solid #409eff;
        }
      }
      .delete-img {
        opacity: 0;
        display: inline-block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        img {
          position: absolute;
          right: -5px;
          top: -5px;
        }
      }
      .delete-img:hover {
        opacity: 1;
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }

  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;
        &:before {
          transform: scale(0.6);
          display: inline-block;
          vertical-align: -3px;
        }
        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>
